<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useNotificationsStore } from '~~/stores/notificationsStore'

const store = useNotificationsStore()
const { notifications } = storeToRefs(store)
</script>

<template>
  <Teleport to="body">
    <div class="app-toast-container" aria-live="polite" aria-atomic="false">
      <TransitionGroup name="toast" tag="div" class="app-toast-list">
        <div
          v-for="n in notifications"
          :key="n.id"
          class="app-toast"
          :class="`app-toast--${n.type}`"
          role="status"
        >
          <span class="app-toast__message">{{ n.message }}</span>
          <button
            type="button"
            class="app-toast__close"
            aria-label="Zamknij powiadomienie"
            @click="store.remove(n.id)"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.app-toast-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 9999;
  pointer-events: none;
}

.app-toast-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;
}

.app-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  font-size: 0.875rem;
  font-weight: var(--font-weight-normal);
  color: var(--color-white);
  pointer-events: all;
  min-width: 240px;
  max-width: 360px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  line-height: 1.4;
}

.app-toast--success { background: var(--color-success); }
.app-toast--error   { background: var(--color-error); }
.app-toast--info    { background: var(--color-info); }

.app-toast__message { flex: 1; }

.app-toast__close {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 2px;
  opacity: 0.75;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: opacity 0.15s;
}
.app-toast__close:hover { opacity: 1; }

.toast-enter-active,
.toast-leave-active { transition: all 0.25s ease; }
.toast-enter-from   { opacity: 0; transform: translateX(20px); }
.toast-leave-to     { opacity: 0; transform: translateX(20px); }
</style>
